export default "__VITE_ASSET__CY4XJpiX__"